export enum ContactNoteStatus {
  SUBMITTED = 'SUBMITTED',
  EDITABLE = 'EDITABLE',
}
